import Button from "components/Button/Button";
import IconButton from "components/IconButton";
import styled from "styled-components";
import { Form } from "styles/formStyles";

interface StyledFormProps {
  $noPadding: boolean;
}

export const StyledForm = styled(Form)<StyledFormProps>`
  border: none;
  justify-content: flex-start;
  ${({ $noPadding }) => ($noPadding ? "padding: 0;" : "")}
`;

export const primaryCellWidth = "220px";
export const secondaryCellWidth = "82px";

interface StyledTableProps {
  disabled: boolean;
  $isWizardStep: boolean;
  $readOnly: boolean;
  $isShowHSCodeColumn: boolean;
}

export const StyledTable = styled.table<StyledTableProps>`
  border-collapse: collapse;
  margin-bottom: 20px;
  table-layout: fixed;
  ${({ disabled }) => (disabled ? "pointer-events: none; opacity: 0.5;" : "")}
  overflow-y: auto;
  height: ${({ $isWizardStep }) => ($isWizardStep ? "400px" : "100%")};
  min-height: 185px;

  display: block;

  thead th {
    ${({ theme, $isShowHSCodeColumn }) => `padding: 10px 0;
  border: 1px solid ${theme.divider};
  width: ${$isShowHSCodeColumn ? "50px" : secondaryCellWidth};

  &:nth-child(1) {
    width: ${$isShowHSCodeColumn ? "170px" : primaryCellWidth};
  }

  &:nth-child(2) {
    width: ${$isShowHSCodeColumn ? "100px" : secondaryCellWidth};
}
  `}
  }

  thead tr {
    display: block;
  }

  tbody {
    display: block;

    ${({ $readOnly }) => ($readOnly ? "pointer-events: none;" : "")}
  }

  tbody td {
    ${({ $isShowHSCodeColumn }) => `
  width: ${$isShowHSCodeColumn ? "50px" : secondaryCellWidth};

  &:nth-child(1) {
    width: ${$isShowHSCodeColumn ? "170px" : primaryCellWidth};
  }

  &:nth-child(2) {
    width: ${$isShowHSCodeColumn ? "100px" : secondaryCellWidth};
  `}
  }

  thead {
    position: sticky;
    z-index: 2;
    background: ${({ theme }) => theme.surface};
    display: block;
  }

  thead {
    inset-block-start: 0; /* "top" */
  }
`;

export const DeleteButton = styled(IconButton).attrs({
  compact: true,
  tone: "danger",
})`
  display: none;
  position: absolute;
  right: 0;
  z-index: 1;
  top: 7px;
`;

interface SaveButtonProps {
  $alignCenter: boolean;
}

export const SaveButton = styled(Button)<SaveButtonProps>`
  margin-left: auto;
  ${({ $alignCenter }) => ($alignCenter ? "margin: auto;" : "")}
`;

export const Row = styled.tr`
  &:hover {
    ${DeleteButton} {
      display: inline-flex !important;
    }
  }
`;

export const LastRow = styled.tr`
  input {
    background-color: ${({ theme }) => theme.snow} !important;
  }
`;

interface CellProps {
  size?: string;
  $invalid?: boolean;
}

export const Cell = styled.td<CellProps>`
  position: relative;
  padding: 0;
  ${({ theme, size }) => `
    border: 1px solid ${theme.divider};
    width: ${size === "large" ? primaryCellWidth : secondaryCellWidth};
  `}

  input {
    ${({ theme, $invalid }) => `
      border: ${$invalid ? `1px solid ${theme.red}` : "none"};
    `}
    box-shadow: none;
    padding-right: 10px;
  }
`;

export const AddUrlCheckboxWrapper = styled.div`
  margin-bottom: 10px;
  align-self: flex-start;
`;

export const UrlRow = styled.tr`
  background-color: ${({ theme }) => theme.selectedRowBg};
`;

interface UrlCellProps {
  $isShowHSCodeColumn: boolean;
}

export const UrlCell = styled.td<UrlCellProps>`
  position: relative;
  padding: 0;
  border: 1px solid ${({ theme }) => theme.divider};
  border-top: none;
  ${({ $isShowHSCodeColumn }) =>
    $isShowHSCodeColumn
      ? "width: 370px;"
      : `width: calc(${primaryCellWidth} + ${secondaryCellWidth} + ${secondaryCellWidth});`}

  input {
    border: none !important;
    box-shadow: none !important;
    background-color: transparent !important;
    width: 100%;
  }
`;
